/**
 * Telegram Mini App wrapper for the unified practice history (Daily Focus
 * sets + Weekly Mocks). URL: /tg/practice-history
 *
 * Reuses PracticeHistory — TelegramShell handles initData → JWT handshake,
 * after which the regular component runs with auth in context. The page is
 * /tg-aware, so item taps + back stay inside the Mini App.
 */

import React from 'react';
import TelegramShell from '../components/TelegramShell';
import PracticeHistory from './PracticeHistory';

const TelegramPracticeHistory: React.FC = () => (
  <TelegramShell>
    <PracticeHistory />
  </TelegramShell>
);

export default TelegramPracticeHistory;
